import script from "./SectionTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./SectionTitle.vue?vue&type=script&lang=ts&setup=true"

import "./SectionTitle.vue?vue&type=style&index=0&id=35f9070e&lang=css"

const __exports__ = script;

export default __exports__